<template>
<div style="width: 100%; cursor: pointer;" @dblclick="onDblClickName">
  <el-select size="mini" style="width: 100%;" @change="onChangeSelection" ref="nameField" v-model="targetData.mappingValue" v-if="(targetData.conditionData !== '')">
    <el-option v-for="item in targetBasicInfoList" :key="item.basicinfoSubid" :value="item[valueField]" :label="item.basicinfoSubname"></el-option>
  </el-select>
  <el-input ref="nameField" v-else-if="(targetData.datatypeId === 'STRING')" v-model="targetData.mappingValue"></el-input>
  <el-input ref="nameField" v-else-if="(targetData.datatypeId === 'INTEGER')" v-model="targetData.mappingValue"></el-input>
</div>
</template>

<script>
import capitalize from 'lodash/capitalize';
import isNil from 'lodash/isNil';
import findIndex from 'lodash/findIndex';
import { EMPTY_TEXT } from '@/utils/string';

const mappingKey = {
  PROTOCOL_FORMAT: '%DY_PROTOCOL_FORMAT%',
};

export default {
  name: 'WObjKeySettingValueComponent',
  props: {
    targetData: {
      type: Object,
      default: () => {},
    },
    basicinfoSetList: {
      type: Object,
      default: () => {},
    },
    objInfo: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      editing: false,
      targetBasicInfoList: [],
      labelField: 'basic',
    };
  },
  computed: {
    valueField() {
      if (!isNil(this.targetData) && this.targetData.mappingKey !== mappingKey.PROTOCOL_FORMAT) {
        return `basicinfoSubvalue${capitalize(this.targetData.datatypeId)}`;
      }
      return 'basicinfoSubid';
    },
  },
  watch: {
    editing(val) {
      if (val === true) {
        this.$nextTick(() => {
          this.$refs.nameField.focus();
        });
      }
    },
    targetData: {
      immediate: true,
      handler() {
        this.$nextTick(() => {
          const val = this.basicinfoSetList;
          if (val.CARD_ADDRESS) {
            if (this.targetData.conditionData !== '') {
              this.targetBasicInfoList = [];
              // basicinfo
              const targetData = this.targetData.conditionData;
              const replaceData = targetData.replace(/(['"])?([a-z0-9A-Z_]+)(['"])?:/g, '"$2": ');
              const jsonData = JSON.parse(replaceData);
              if (jsonData.condition.basicinfoId === 'CARD_ADDRESS') {
                this.targetBasicInfoList = this.basicinfoSetList.CARD_ADDRESS;
              } else if (jsonData.condition.basicinfoId === 'MODULE_ADDRESS') {
                this.targetBasicInfoList = this.basicinfoSetList.MODULE_ADDRESS;
              } else if (jsonData.condition.basicinfoId === 'CHANNEL_ADDRESS') {
                this.targetBasicInfoList = this.basicinfoSetList.CHANNEL_ADDRESS;
              } else if (jsonData.condition.basicinfoId === 'PORT_ADDRESS') {
                this.targetBasicInfoList = this.basicinfoSetList.PORT_ADDRESS;
              } else if (jsonData.condition.basicinfoId === '%rsctypeId%') {
                // 프로토콜 포맷 - "%rsctypeId%"
                this.targetBasicInfoList = this.basicinfoSetList[this.objInfo.obj.objtypeId];
              }
              if (!isNil(this.targetBasicInfoList) && findIndex(this.targetBasicInfoList, ['basicinfoSubid', null]) < 0) {
                this.targetBasicInfoList.unshift({
                  basicinfoSubid: null,
                  basicinfoSubname: '선택없음',
                });
              }
            }
          }
        });
      },
    },
  },
  methods: {
    onChangeSelection() {
      // this.editing = !this.editing;
    },
    onDblClickName() {
      this.editing = !this.editing;
    },
    // column data formatter
    getEmptyText(value) {
      if (!isNil(value) && value !== '') {
        return value;
      }
      return EMPTY_TEXT;
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/performance/node/popup/components/ObjKeySettingValueComponent.vue